export default {
  language: '語言',
  addMultiLang: '添加多語言',
  delete: '刪除',
  save: '保存',
  addMultiLangModalTitle: '會員多語言信息',
  deleteMultiLangModalTitle: '刪除多語言',
  selectLangWarning: '請至少選擇一種語言',
  addLangSuccess: '添加語言成功',
  deleteLangSuccess: '刪除語言成功',
  deleteLangFailed: '刪除語言失敗',
  contentRequired: '請輸入售後反饋內容',
  saveSuccess: '保存成功',
  saveFailed: '保存失敗',
  loadFailed: '加載售後反饋內容失敗',
  placeholder: '請輸入售後反饋內容',
};
